// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"addc4488","354":"9bca1350","391":"0c43dedd","455":"e021a6ef","488":"1a9a8f8c","685":"729ef1fc","977":"3d2c2926"}[chunkId] + ".chunk.js";
};